import React, { useEffect } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import styled from 'styled-components/macro';
/**
 * TODO: might be nice to just not use material ui base for this so we can use style component
 * reference for this style is based off https://material-ui.com/components/selects/ (customized selects part)
 */

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
        color: 'black',
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: '0.8rem',
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create([
        'border-color',
        'box-shadow',
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    margin: {
      marginTop: theme.spacing(1),
      width: '100%',
    },
    menuItem: {
      fontSize: '0.8rem',
    },
    inputLabel: {
      color: 'black',
      fontSize: '0.8rem',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      [`&.MuiInputLabel-shrink`]: {
        transform: 'scale(1)',
      },
    },
  }),
);

interface MainDropdownProps {
  name?: string;
  label?: string;
  defaultValue: string; // this is used to set the state.value
  options?: any[];
  handleChange?: Function;
  disabled?: boolean;
  recommendedValue?: string;
}
const MainDropdown: React.FC<MainDropdownProps> = ({
  name,
  label,
  defaultValue = '',
  options,
  handleChange: handleChangeFromProps,
  disabled,
  recommendedValue = '',
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState('');

  // when defaultValue changes (from props) will reset the value
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (handleChangeFromProps)
      handleChangeFromProps(event.target.value);
  };

  return (
    <FormControl className={classes.margin}>
      {label && (
        <InputLabel
          shrink
          id={`${name}-label`}
          className={classes.inputLabel}
        >
          {label}
        </InputLabel>
      )}
      {/* might decide to use this design so save it */}
      {/* {recommendedValue === defaultValue && (
        <SRecommendedValue>
          <div>Recommended Value</div>
        </SRecommendedValue>
      )} */}
      <Select
        labelId={`${name}-label`}
        id={name}
        value={value}
        onChange={handleChange}
        // // DO NOT USE defaultValue={defaultValue} HERE (because we already deal with it in state)
        input={<BootstrapInput />}
        disabled={disabled}
      >
        {options &&
          options.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className={classes.menuItem}
            >
              <SMenu>
                <div>{option}</div>
                {option === recommendedValue && (
                  <SRecommendationTag>Recommend</SRecommendationTag>
                )}
              </SMenu>
            </MenuItem>
          ))}
      </Select>
      {/* <FormHelperText>Label + placeholder</FormHelperText> */}
    </FormControl>
  );
};

export default MainDropdown;

// might decide to use this design so save it
// const SRecommendedValue = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: flex-end;
//   margin-bottom: 10px;
//   & > div {
//     padding: 2px 5px;
//     border-radius: 20px;
//     background-color: #fbecf5;
//     color: #e69cc4;
//   }
// `;
const SMenu = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const SRecommendationTag = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.palette.primary.main};
  background: ${(props) =>
    props.theme.palette.background.mediumLightPink};
  border-radius: 10px;
  padding: 2px 10px;
  font-size: ${(props) => props.theme.typography.fontSize.extraSmall};
`;
